import React, { Component } from "react";
import { Query } from "react-apollo";
import { Select } from "antd";
import * as R from "ramda";

import { debounce, timeout } from "../../util";
import { countryIsoCodeToName } from "../../formatters";
import { SEARCH_ENTITY_NAMES } from "./queries";

const searchFieldOption = option => {
    const isCompleted = R.last(option.requests).isCompleted;
    const countryName = countryIsoCodeToName(option.countryCode);
    const appendix = isCompleted ? null : <i>(In progress)</i>;

    return (
        <Select.Option
            key={option.ulid}
            value={option.ulid}
            disabled={!isCompleted}
        >
            {option.name} ({countryName}) {appendix}
        </Select.Option>
    );
};

class SearchField extends Component {
    state = {
        value: undefined,
        options: [],
    };

    constructor(props) {
        super(props);
        this.preventReset = false;
    }

    setResetPreventer = async () => {
        this.preventReset = true;
        await timeout(100);
        this.preventReset = false;
    };

    refreshResults = debounce(async () => {
        const results = await this.props.apolloProps.refetch({
            name: this.state.value,
        });
        const edges = R.pathOr(
            [],
            ["data", "groupedResearchRequests", "edges"],
            results
        );

        this.setState(
            {
                options: R.map(
                    R.pipe(
                        R.prop("node"),
                        R.pick(["ulid", "name", "requests", "countryCode"])
                    )
                )(edges),
            },
            () => {
                this.props.refreshData(this.state.value);
            }
        );
    }, 200);

    handleSearch = debounce(value => {
        if (value) {
            this.setState({ value }, this.refreshResults);
        } else if (!this.preventReset) {
            this.setState({
                value: undefined,
            });
        }
    }, 10);

    handleSelect = ulid => {
        const entity = this.state.options.find(entity => entity.ulid === ulid);
        this.props.handleSelect(R.last(entity.requests).ulid);
    };
    /**
     * Spike for preventing reset of "search-input" field.
     * In normal situation, if antd select is closed and search field if not empty, it resets on blur
     * see Select.js ln 693
     */
    handleBlur = () => {
        this.setResetPreventer();
    };

    render() {
        return (
            <Select
                {...this.props}
                showSearch
                value={this.state.value}
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                onSearch={this.handleSearch}
                onSelect={this.handleSelect}
                onBlur={this.handleBlur}
                notFoundContent={null}
            >
                {R.map(searchFieldOption, this.state.options)}
            </Select>
        );
    }
}

export default props => (
    <Query
        query={SEARCH_ENTITY_NAMES}
        fetchPolicy="cache-and-network"
        variables={{
            name: "",
        }}
    >
        {apolloProps => {
            return <SearchField {...props} apolloProps={apolloProps} />;
        }}
    </Query>
);
